var _circle, _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLoginManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6667,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 26.7684H22.0222C22.3778 25.4926 23.549 24.5723 24.8875 24.5723C26.2261 24.5723 27.4183 25.4926 27.7529 26.7684H29.4469V28.337H27.7529C27.3973 29.6128 26.2261 30.5331 24.8875 30.5331C23.549 30.5331 22.3568 29.6128 22.0222 28.337H11V26.7684ZM24.8876 25.9737C24.03 25.9737 23.319 26.6848 23.319 27.5424C23.319 28.3999 24.03 29.111 24.8876 29.111C25.7451 29.111 26.4562 28.3999 26.4562 27.5424C26.4562 26.6848 25.7451 25.9737 24.8876 25.9737Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 20.1385H12.276C12.6315 18.8627 13.8027 17.9424 15.1413 17.9424C16.4799 17.9424 17.6721 18.8627 18.0066 20.1385H29.4471V21.7071H18.0066C17.6511 22.9829 16.4799 23.9032 15.1413 23.9032C13.8027 23.9032 12.6105 22.9829 12.276 21.7071H11L11.0001 20.1385ZM15.1413 19.3647C14.2838 19.3647 13.5727 20.0758 13.5727 20.9333C13.5727 21.7909 14.2838 22.5019 15.1413 22.5019C15.9989 22.5019 16.71 21.7909 16.71 20.9333C16.71 20.0758 15.9987 19.3647 15.1413 19.3647Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5294H19.4706C19.8053 12.2536 20.9765 11.3333 22.3359 11.3333C23.6745 11.3333 24.8667 12.2536 25.2012 13.5294H29.447V15.098H25.2012C24.8457 16.3738 23.6745 17.2941 22.3359 17.2941C20.9973 17.2941 19.8051 16.3738 19.4706 15.098H11V13.5294ZM22.3778 12.7554C21.5202 12.7554 20.8092 13.4665 20.8092 14.324C20.8092 15.1816 21.5202 15.8927 22.3778 15.8927C23.2353 15.8927 23.9464 15.1816 23.9464 14.324C23.9464 13.4665 23.2353 12.7554 22.3778 12.7554Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginManage);
export default __webpack_public_path__ + "static/media/login-manage.07fd2700d429a21da23f982bec35c084.svg";
export { ForwardRef as ReactComponent };